<template>
  <label
    @click.prevent="$emit('input', !value)"
    :class="{ 'mds-form__checkbox--hide-label': !label, 'mds-form__checkbox--disabled': disabled }"
    :for="checkboxDomId"
    class="mds-form__checkbox"
  >
    <input
      :id="checkboxDomId"
      :checked="value"
      class="mds-form__checkbox-input"
      type="checkbox"
      :disabled="disabled"
    />
    <span class="mds-form__checkbox-visible-wrap">
      <span class="mds-form__checkbox-visual">
        <mds-icon
          name="check"
          size="small"
          class="mds-icon mds-form__checkbox-checked-icon"
          aria-hidden="true"
        />
        <mds-icon
          name="minus"
          size="small"
          class="mds-icon mds-form__checkbox-indeterminate-icon"
          aria-hidden="true"
        />
      </span>
      <span v-if="label" class="mds-form__checkbox-text"> {{ label }} </span>
    </span>
  </label>
</template>

<script>
import { v4 } from 'uuid';
import MdsIcon from '@mds/icon';

export default {
  name: 'check-box',
  components: {
    MdsIcon,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checkboxDomId() {
      return v4();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@mds/constants';
  @import '@mds/icon/src/icon_mixins';

  .mds-icon {
    @include mds-icon-color($mds-color-white);
  }
</style>
